import { InputText, Text } from "@pentabd/ui";

export const ProcurementDetailsForm = () => {
  return (
    <div className="d-flex flex-column gap-8">
      <div className="row">
        <div className="col-lg-12 col-xl-6">
          <div className="row">
            <div className="col-md-12 col-lg-3">
              <Text weight="semibold" color="title" size="sm">
                Name
              </Text>
            </div>
            <div className="col-md-12 col-lg-7">
              <InputText
                name="name"
                className="fs-md"
                placeholder="Enter Name"
                disabled
              />
            </div>
          </div>
        </div>
        <div className="col-lg-12 col-xl-6">
          <div className="row">
            <div className="col-md-12 col-lg-3">
              <Text weight="semibold" color="title" size="sm">
                Created Date
              </Text>
            </div>
            <div className="col-md-12 col-lg-7">
              <InputText
                name="date"
                className="fs-md"
                placeholder="Enter Name"
                disabled
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 col-xl-6">
          <div className="row">
            <div className="col-md-12 col-lg-3">
              <Text weight="semibold" color="title" size="sm">
                Ref no.
              </Text>
            </div>
            <div className="col-md-12 col-lg-7">
              <InputText
                name="ref"
                className="fs-md"
                placeholder="Enter Name"
                disabled
              />
            </div>
          </div>
        </div>
        <div className="col-lg-12 col-xl-6">
          <div className="row">
            <div className="col-md-12 col-lg-3">
              <Text weight="semibold" color="title" size="sm">
                Year
              </Text>
            </div>
            <div className="col-md-12 col-lg-7">
              <InputText
                name="year"
                className="fs-md"
                placeholder="Enter Name"
                disabled
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 col-xl-6">
          <div className="row">
            <div className="col-md-12 col-lg-3">
              <Text weight="semibold" color="title" size="sm">
                APP Total Budget
              </Text>
            </div>
            <div className="col-md-12 col-lg-7">
              <InputText
                name="AppTotalBudget"
                className="fs-md"
                placeholder="Enter Name"
                disabled
              />
            </div>
          </div>
        </div>
        <div className="col-lg-12 col-xl-6">
          <div className="row">
            <div className="col-md-12 col-lg-3">
              <Text weight="semibold" color="title" size="sm">
                Package Budget
              </Text>
            </div>
            <div className="col-md-12 col-lg-7">
              <InputText
                name="packageBudget"
                className="fs-md"
                placeholder="Enter Name"
                disabled
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
